import { PaymentErrorPathsEnum, PaymentErrorsEnum } from '@src/domains/payments/types/payment';

export const checkInsufficientAmountError = (errors: { [key: string]: string[] }) => {
  const errorPaths = [
    PaymentErrorPathsEnum.ORDER_ID,
    PaymentErrorPathsEnum.SALE_ID,
    PaymentErrorPathsEnum.DIRECT_LINK_ID,
    PaymentErrorPathsEnum.PAYMENT_ID,
  ];

  const orderIdErrors = errorPaths
    .map((path) => errors?.[path])
    .flat()
    .filter(Boolean);

  return orderIdErrors.some((error) => error === PaymentErrorsEnum.INSUFFICIENT_AMOUNT);
};
